import styled from 'styled-components'

const StyledPageActions = styled.div`
  display: flex;
  min-width: fit-content;
  justify-content: flex-end;
`
export default StyledPageActions
